import { createAction } from '@reduxjs/toolkit';

const postEasyShipShipmentClearError = createAction('postEasyShipShipmentClearError');

export default postEasyShipShipmentClearError;
